import { DateTime } from "luxon";

export const toTitleCaseName = (name) => {
  if (!name || typeof name !== "string") return "";

  return name
    .trim()
    .toLowerCase()
    .replace(/(^|[\s'-])[a-z]/g, (letter) => letter.toUpperCase());
};

export const formatAcceptanceTime = (
  acceptedAt,
  timezone = "America/New_York",
) => {
  if (!acceptedAt) return "";

  const parsed =
    typeof acceptedAt === "number"
      ? DateTime.fromSeconds(acceptedAt, { zone: "utc" })
      : DateTime.fromISO(String(acceptedAt), { zone: "utc" });

  if (!parsed.isValid) return "";

  return parsed.setZone(timezone).toFormat("MMMM d, yyyy 'at' h:mm a ZZZZ");
};
